import { Container } from "../ui/Section";
import { MotionItem, fadeUp, fadeUpSmall, scaleIn } from "../ui/Motion";
import {
  Wrapper,
  Glow,
  Content,
  Eyebrow,
  Title,
  Description,
  Actions,
  PrimaryBtn,
  SecondaryBtn,
} from "./styles/CtaSection.styles";

function CtaSection() {
  return (
    <Wrapper>
      <Glow />
      <Container>
        <Content slow>
          <MotionItem $variants={fadeUpSmall}>
            <Eyebrow>Start Your Journey</Eyebrow>
          </MotionItem>

          <MotionItem $variants={fadeUp}>
            <Title>
              Find Your <em>Perfect</em> Yacht
            </Title>
          </MotionItem>

          <MotionItem $variants={fadeUpSmall}>
            <Description>
              Whether you're drawn to a new Princess Yacht or a distinguished
              pre-owned vessel, our team is ready to guide every step, from
              discovery to delivery.
            </Description>
          </MotionItem>

          <MotionItem $variants={scaleIn}>
            <Actions>
              <PrimaryBtn to="/contact">Send an Inquiry</PrimaryBtn>
              <SecondaryBtn to="/yachts">Browse Yachts</SecondaryBtn>
            </Actions>
          </MotionItem>
        </Content>
      </Container>
    </Wrapper>
  );
}

export default CtaSection;
